/*
  Escritura automática de la tarjeta del comparador en el megamenú.

  Dos diferencias con el original de la diseñadora:

  - **Solo escribe mientras la tarjeta se ve.** El original dejaba un
    `setTimeout` encadenado corriendo para siempre en todas las páginas, con
    el menú cerrado incluido. Aquí un IntersectionObserver lo arranca al
    abrirse el menú y lo para al cerrarlo.
  - **Respeta `prefers-reduced-motion`**: quien pide menos movimiento se queda
    con la primera frase fija, sin animación.
*/
(() => {
  const menosMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const arrancar = (nodo) => {
    if (nodo.dataset.cmpMenuListo === 'true') return;
    nodo.dataset.cmpMenuListo = 'true';

    const frases = (nodo.dataset.cmpMenuFrases || '')
      .split('|')
      .map((f) => f.trim())
      .filter(Boolean);

    if (frases.length < 2 || menosMovimiento) return;

    let indice = 0;
    let letras = 0;
    let borrando = false;
    let temporizador = null;
    let visible = false;

    const paso = () => {
      const frase = frases[indice];
      nodo.textContent = frase.slice(0, letras);

      let espera;
      if (!borrando && letras < frase.length) {
        letras += 1;
        espera = 85;
      } else if (!borrando) {
        borrando = true;
        espera = 1400;
      } else if (letras > 0) {
        letras -= 1;
        espera = 35;
      } else {
        borrando = false;
        indice = (indice + 1) % frases.length;
        espera = 300;
      }

      if (visible) temporizador = setTimeout(paso, espera);
    };

    const arrancarBucle = () => {
      if (visible) return;
      visible = true;
      paso();
    };

    const pararBucle = () => {
      visible = false;
      clearTimeout(temporizador);
    };

    // En escritorio la tarjeta vive dentro del <details> del megamenú, así que
    // lo que manda es si ese desplegable está abierto. No vale mirar si se ve
    // en pantalla: el panel se coloca por encima del viewport y un
    // IntersectionObserver lo da por invisible aunque el menú esté abierto.
    const desplegable = nodo.closest('details');

    if (desplegable) {
      desplegable.addEventListener('toggle', () => {
        if (desplegable.open) arrancarBucle();
        else pararBucle();
      });
      if (desplegable.open) arrancarBucle();
      return;
    }

    // En móvil la tarjeta va dentro del cajón, que es un <dialog>: cerrado no
    // tiene caja y el observador lo resuelve bien.
    const observador = new IntersectionObserver((entradas) => {
      entradas.forEach((entrada) => {
        if (entrada.isIntersecting) arrancarBucle();
        else pararBucle();
      });
    });

    observador.observe(nodo);
  };

  const buscar = () => document.querySelectorAll('[data-cmp-menu-frases]').forEach(arrancar);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buscar, { once: true });
  } else {
    buscar();
  }
})();
